<template>
  <div>
    <CRow>
      <CCol col="12">
        <p class="font-weight-bold"> {{ type }} </p>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CCard accent-color="secondary">
          <CCardHeader v-if="!icon">
            <slot name="header" >
              <CIcon v-if="icon" :name="icon"/> <span class="font-weight-bold">{{caption}}</span>
              <div class="card-header-actions">
                <CButton size="sm" color="success" shape="pill" variant="outline"> <CIcon name="cil-library-add"/> </CButton>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody class="p-0">
            <CDataTable
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="items"
                :fields="fields"
                :items-per-page="small ? 50 : 20"
                :dark="dark"
                pagination
            >
              <template #tag="{item}">
                <td>
                  <div class="mt-2">
                    <div v-if="item.tag == 1" style="width: 20px; height: 20px; background-color: black; border-radius: 10px;"></div>
                    <div v-if="item.tag == 2" style="width: 20px; height: 20px;  border-radius: 10px; border: 2px solid black"></div>
                  </div>
                </td>
              </template>
              <template #plo="{item}">
                <td style="min-width: 200px">
                  <div v-html="item.plo"></div>
                </td>
              </template>
              <template #lo="{item}">
                <td>
                  <div v-html="item.lo"></div>
                </td>
              </template>
              <template #clo="{item}">
                <td>
                  <div v-html="item.clo"></div>
                </td>
              </template>
              <template #level="{item}">
                <td>
                  <div v-html="item.level"></div>
                </td>
              </template>
              <template #teaching="{item}">
                <td>
                  <div v-html="item.teaching"></div>
                </td>
              </template>
              <template #assessment="{item}">
                <td>
                  <div v-html="item.assessment"></div>
                </td>
              </template>
              <template #methods="{item}">
                <td style="min-width: 100px">
                  <!--            {{item.methods}}-->
                  <!--            <div>{{item.methods.filter(objs => { objs.value})}}</div>-->
                  {{ onCheckE(item.methods) }}
                </td>
              </template>
              <template #action="{item}">
                <td style="width: 140px">
                  <CRow>
                    <CCol class="text-center">
<!--                      <CButton class="mr-1" size="sm" color="success" shape="pill" variant="outline" @click="onAdd(index)" >-->
<!--                        <CIcon name="cil-plus"/>-->
<!--                      </CButton>-->
                      <CButton class="mr-1" v-c-tooltip.hover.click="'Edit Methods'" size="sm" color="info" shape="pill" variant="outline" @click="onEdit(item)" >
                        <CIcon name="cil-pencil"/>
                      </CButton>
                      <CButton class="mr-1" v-c-tooltip.hover.click="'Studens'" size="sm" color="success" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                        <CIcon name="cil-people"/>
                      </CButton>
                      <CButton class="mr-1" :disabled="(item.methods.length > 0)?false:true" v-c-tooltip.hover.click="'Download'" size="sm" color="warning" shape="pill" variant="outline" @click="onExport(item)" >
                        <CIcon name="cil-cloud-download"/>
                      </CButton>

                      <MUploadFile :item="item" v-c-tooltip.hover.click="'Upload'" />


                    </CCol>
                  </CRow>
                </td>
              </template>

              <template #details="{item}">
                <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
                  <CCardBody>
                    <CDataTable
                        table-filter
                        :items="item.students"
                        :fields="item.fields"
                        items-per-page-select
                        :items-per-page="50"
                        hover
                        sorter
                        pagination
                    >
                      <template #no="{item,index}">
                        <td> {{index+1}} </td>
                      </template>

                      <template #section="{item,index}" >
                        <td style="text-align: center"> {{item.section}} </td>
                      </template>

                      <template #members="{item,index}">
                        <td>
                          <p class="mb-0"> {{item.code}}</p>
                          <p class="mb-0" style="white-space: nowrap;">{{item.prefix}}. {{item.firstName}} {{item.lastName}}</p>
                        </td>
                      </template>


                      <template #avata="{item,index}">
                        <td>
                          <div class="c-avatar">
                            <img :src="src" class="c-avatar-img" alt="">
                            <span
                                class="c-avatar-status"
                                :class="`bg-success`"
                            ></span>
                          </div>
                        </td>
                      </template>

                      <template #max="{item,index}">
                        <td><CInput type="number" min="0" max="100" v-model="item.max"></CInput> </td>
                      </template>


                      <template #mcq="{item,index}">
                        <td><CInput type="number" min="0" max="100" v-model="item.mcq"></CInput> </td>
                      </template>

                      <template #crq="{item,index}">
                        <td><CInput type="number" min="0" max="100" v-model="item.crq"></CInput> </td>
                      </template>

                      <template #essay="{item,index}">
                        <td><CInput type="number" min="0" max="100" v-model="item.essay"></CInput> </td>
                      </template>

                      <template #lab="{item,index}">
                        <td><CInput type="number" min="0" max="100" v-model="item.lab"></CInput> </td>
                      </template>

                      <template #osce="{item,index}">
                        <td><CInput type="number" min="0" max="100" v-model="item.osce"></CInput> </td>
                      </template>


                      <template #dateTime="{item,index}">
                        <td> {{moment(item.dateTime).format("YYYY-MM-DD HH:MM:ss")}} </td>
                      </template>



                    </CDataTable>
                  </CCardBody>
                </CCollapse>
              </template>

            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <MethodAssessment :dialog="isDialog" :item="method" />
  </div>

</template>

<script>
import * as XLSX from 'xlsx'
import {mapGetters} from "vuex";
import MethodAssessment from "@/projects/views/E-Port/components/LearningOutcome/MethodAssessment";
import MUploadFile from "@/projects/components/Util/MUploadFile";

export default {
  name: 'LearningOutcome',
  components: {MUploadFile, MethodAssessment},
  props: {
    items:  {
      type: Array
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: 'plo', label: 'Plo', _style: "width:300px"},
          {key: 'teaching', label: 'Teaching'},
          {key: 'methods', label: 'Methods', _style: 'width:100px'},
          {key: 'action', label: '#', _style: 'width:280px; text-align: center'},
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },
  data: function () {
    return {
      collapseDuration: 0,
      isDialog:false,
      method : [],
      src:"https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    }
  },
  methods: {

    onExport(item) {
      const dataWS = XLSX.utils.json_to_sheet(item.students)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb,item.plo+'.xlsx')
    },

    onRemove(item){
      // this.items = this.items.filter(function(obj) {return obj != item;})
      this.$emit("onRemove",item)
    },
    onEdit(item){
      this.isDialog = false;
      this.isDialog = true;
      this.method = item;
    },

    onCheckE(item){
     try {
       var text = ""
       // for(var i=0; i<item.length; i++){
       //   try {
       //     var sum = item[i].value.reduce( (count, objs) => {
       //
       //       return count + objs.value;
       //     }, 0);
       //
       //
       //     text += item[i].title
       //
       //     console.log("111",item[i].title)
       //
       //   }catch (e) {
       //     console.log(e)
       //   }
       // }

       return item[0].title
     }catch (e) {

     }


    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    }
  },

}
</script>
